import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Box,
  Flex,
  Text,
  FormControl,
  FormLabel,
  Select,
} from "@chakra-ui/react";
import { FaDownload } from "react-icons/fa";

const GeneratedFileView = ({
  isOpen,
  onClose,
  files,
  onRegenerateClick,
  handleSendForApprovalClick,
  isLoading,
  initialFormData,
}) => {
  const [showFontInput, setShowFontInput] = useState(false);
  const [fontSize, setFontSize] = useState("");
  const [error, setError] = useState("");

  // Add font size options
  const fontSizeOptions = [
    { value: "xsmall", label: "Extra Small" },
    { value: "small", label: "Small" },
    { value: "medium", label: "Medium" },
    { value: "large", label: "Large" },
    { value: "xlarge", label: "Extra Large" },
  ];

  // Helper function to get file type label
  const getFileTypeLabel = (type) => {
    switch (type) {
      case "al":
        return "Appointment Letter";
      case "mo":
        return "Medical Opinion";
      case "vil":
        return "VIL";
      default:
        return type.toUpperCase();
    }
  };

  // Convert files object to array for easier mapping
  const fileEntries = Object.entries(files || {});

  const handleDownload = (url) => {
    window.open(url, "_blank");
  };

  const handleRegenerateClick = () => {
    setShowFontInput(true);
  };

  const handleFontSizeSubmit = () => {
    if (!fontSize) {
      setError("Please select a font size");
      return;
    }

    // Call regenerate with font size and initial form data
    onRegenerateClick({
      ...initialFormData,
      font: fontSize,
    });

    setShowFontInput(false);
    setFontSize("");
    setError("");
  };

  const handleModalClose = () => {
    setShowFontInput(false);
    setFontSize("");
    setError("");
    onClose();
  };
  return (
    <Modal isOpen={isOpen} onClose={handleModalClose} size="4xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader bg="green.500" color="white" borderTopRadius="md">
          Generated Files
        </ModalHeader>
        <ModalBody maxH="70vh" overflowY="auto" p={4}>
          {showFontInput ? (
            <Box
              mb={4}
              p={4}
              border="1px"
              borderColor="gray.200"
              borderRadius="md"
            >
              <FormControl isInvalid={!!error}>
                <FormLabel>Select Font Size</FormLabel>
                <Select
                  value={fontSize}
                  onChange={(e) => setFontSize(e.target.value)}
                  placeholder="Select font size"
                >
                  {fontSizeOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Select>
                {error && (
                  <Text color="red.500" fontSize="sm" mt={1}>
                    {error}
                  </Text>
                )}
              </FormControl>
              <Flex justify="flex-end" mt={4}>
                <Button
                  colorScheme="blue"
                  mr={2}
                  onClick={handleFontSizeSubmit}
                  isLoading={isLoading}
                >
                  Submit
                </Button>
                <Button variant="ghost" onClick={() => setShowFontInput(false)}>
                  Cancel
                </Button>
              </Flex>
            </Box>
          ) : (
            fileEntries.map(([type, url], index) => (
              <Box
                key={type}
                mb={4}
                border="1px"
                borderColor="gray.200"
                borderRadius="md"
                p={4}
              >
                <Flex justify="space-between" align="center" mb={2}>
                  <Text fontWeight="bold">{getFileTypeLabel(type)}</Text>
                  <Button
                    leftIcon={<FaDownload />}
                    colorScheme="blue"
                    size="sm"
                    onClick={() => handleDownload(url)}
                  >
                    Download
                  </Button>
                </Flex>
                <Box
                  w="100%"
                  h="500px"
                  border="1px"
                  borderColor="gray.200"
                  borderRadius="md"
                  overflow="hidden"
                >
                  <iframe
                    src={`${url}#toolbar=0`}
                    width="100%"
                    height="100%"
                    title={`PDF Preview ${index + 1}`}
                    style={{ border: "none" }}
                  />
                </Box>
              </Box>
            ))
          )}
        </ModalBody>
        <ModalFooter bg="gray.50" borderBottomRadius="md">
          {!showFontInput && (
            <>
              <Button
                colorScheme="blue"
                mr={3}
                onClick={handleRegenerateClick}
                isLoading={isLoading}
              >
                Regenerate PDF
              </Button>

              {/* {(fileEntries.some(([type]) => type.toLowerCase() === "mo") ||
                fileEntries.some(([type]) => type.toLowerCase() === "vil")) && ( */}
              {fileEntries.some(
                ([type]) =>
                  type.toLowerCase() === "mo" || type.toLowerCase() === "al"
              ) && (
                <Button
                  colorScheme="blue"
                  mr={3}
                  onClick={handleSendForApprovalClick}
                  isLoading={isLoading}
                >
                  {fileEntries.some(([type]) => type.toLowerCase() === "vil")
                    ? "Send for Approval"
                    : "Confirm"}
                </Button>
              )}
            </>
          )}
          <Button variant="ghost" onClick={handleModalClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default GeneratedFileView;
